module.exports = __webpack_public_path__ + "fonts/MicrogrammaD-BoldExte.394bf7d.ttf";